<template>
  <modal
          name="infoItem"
          height="auto"
          width="600px"
          :scrollable="true"
  >
  <div class="window-header">
    {{ itemTitle }}
    <a href="javascript:void(0)" class="close-modal pull-right" @click="$modal.hide('infoItem')">
      <i class="fa fa-times"></i>
    </a>
  </div>
  <div class="modal-body">
    <div class="page-modal" style="background:white">
      <div class="alert alert-danger alert-dismissable" v-show="error !== ''">
        <strong>Error </strong>
        <div class="errorMsg" style="display: inline-block;">{{ error }}</div>
      </div>
      <div class="alert alert-info alert-dismissable" v-show="info != ''">
        <strong>
          <b-icon icon="info-circle-fill"></b-icon>
        </strong>
        <div class="alert-text" style="display: inline-block;"> {{ info }}</div>
      </div>
      <div class="vm-info-buttons">
        <button @click="startVm()" class="btn btn-primary run-btn run-btn-start">Start</button>
        <button @click="stopVm()" class="btn btn-primary run-btn run-btn-vm-stop">Stop</button>
        <button @click="loadData()" class="btn btn-primary run-btn">Update status</button>
      </div>
      <div>
        <b-form-textarea
                class="col-sm-11"
                rows="3"
                v-model="textareaData"></b-form-textarea>
        <button
                type="button"
                class="btn btn-default"
                @click="showTextareaData()"
        >Open modal
        </button>
      </div>
    </div>
  </div>
  <ModalLog :data="textareaData" :modalName="'itemInfoTextarea'" />
  </modal>
</template>

<script>
import axios from 'axios';
import ModalLog from "./ModalLog";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: 'infoItem',
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  components: {
    ModalLog,
  },
  props: {
    type: String,
    itemId: Number,
    modalName: String,
    item: Object,
  },
  data() {
    return {
      error: '',
      info: '',
      apiUrl: '/api/manager/vm/',
      apiConfig: '/api/config/item-form/', //deprecated
      apiVmStart: '/api/manager/vm/start/',
      apiVmStop: '/api/manager/vm/stop/',
      apiVmStatus: '/api/manager/vm/status/',
      login: '/login',
      loading: 'loaded',
      jsonOptions: {
        "modes": ["tree", "code", "text"]
      },
      jsonData: {},
      itemTitle: '',
      textareaData: '',
    }
  },
  methods: {
    startVm () {
      let loader = this.$loading.show();
      this.error = '';
      axios.post(this.apiVmStart + this.itemId, {}, this.authRespConf())
              .catch((err) => {
                loader.hide();
                this.errorHandle(err, true, true);
              })
              .then(res => {
                loader.hide();
                if (res) {
                  if (res.status <= 204) {
                    this.info = 'Command sended';
                  }
                }
              });
    },
    stopVm () {
      let loader = this.$loading.show();
      this.error = '';
      axios.post(this.apiVmStop + this.itemId, {}, this.authRespConf())
              .catch((err) => {
                loader.hide();
                this.errorHandle(err, true, true);
              })
              .then(res => {
                loader.hide();
                if (res) {
                  if (res.status <= 204) {
                    this.info = 'Command sended';
                  }
                }
              });
    },
    returnBackToList() {
      this.$router.go(-1);
    },
    LoadConfig() {
      let loader = this.$loading.show();

      this.title = '...';
      this.filter = [];
      this.items = null;
      this.error = '';
      this.loading = 'loading';
      let pageName = this.$route.name;
      axios.get(this.apiConfig + pageName, this.authRespConf())
          .catch((err) => {
            loader.hide();
            this.loading = 'loaded';
            this.errorHandle(err, true, true);
          })
          .then(res => {
            loader.hide();
            this.loading = 'loaded';
            console.log('loaded config');
            this.apiUrl = res.data.apiUrl;
            this.loadData();
          });
      console.log('after load config func');
    },
    loadData() {
      this.itemTitle = 'loading...';
      this.textareaData = 'loading...';
      let loader = this.$loading.show();
      let entityId = parseInt(this.itemId);
      if (entityId === 0) {
        loader.hide();
        return;
      }
      axios.get(this.apiUrl + entityId, this.authRespConf())
              .then(res => {
                loader.hide();
                if (res) {
                  console.log("item load ", res);
                  if (res.data) {
                    this.item = res.data.data;
                    this.itemTitle = `[${res.data.data.Id}] ${res.data.data.Name} (State ${res.data.data.State})`;
                  }
                }
              })
              .catch((err) => {
                loader.hide();
                this.moveUp();
                this.errorHandle(err, true, true);
              });
      axios.post(this.apiVmStatus + entityId, {}, this.authRespConf())
              .catch((err) => {
                this.errorHandle(err, true, true);
              })
              .then(res => {
                console.log(res);
                if (res !== null && res !== undefined) {
                  this.textareaData = res.data;
                }
              });
    },
    moveUp() {
      window.scrollTo(0, 0);
    },
    onChangeJson() {
      console.log('onChange json');
    },
    showTextareaData() {
      this.$modal.show('itemInfoTextarea');
    },
    showNotifyData() {
      this.$modal.show('itemInfoTextarea');
    },
  },
  mounted() {

  },
  watch: {
    '$route': 'loadData',
    'itemId': 'loadData'
  },
  created: function () {
    if (parseInt(this.itemId) !== 0) {
      this.loadData();
    }
  }
}
</script>
